import { render, staticRenderFns } from "./ChatTemplates.vue?vue&type=template&id=334e6508&scoped=true"
import script from "./ChatTemplates.vue?vue&type=script&lang=js"
export * from "./ChatTemplates.vue?vue&type=script&lang=js"
import style0 from "./ChatTemplates.vue?vue&type=style&index=0&id=334e6508&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334e6508",
  null
  
)

export default component.exports